import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalCertezaCancelarLote({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Cancelar emissão de licenciamentos"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={() => {
        window.location.reload();
      }}
      confirmButtonText="Sim"
      cancelButtonText="Não"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Tem certeza que deseja cancelar a emissão de licenciamentos?
      </ModalBody>
    </ModalCustom>
  );
}
